class ajaxCart extends HTMLElement {
  constructor() {
    super();
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    const overlay = this.querySelector("#ajaxcart-overlay");
    if (overlay) overlay.addEventListener("click", this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#ajax-cart-icon");
    if (!cartLink || cartLink.dataset.drawerReady === "true") return;
    cartLink.dataset.drawerReady = "true";
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });
    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".cart-inner-empty")
          : document.getElementById("ajaxcart");
        const focusElement = this.querySelector(".drawer-inner");
        triggerClick(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
  }
  close() {
    this.classList.remove("active");
    if (typeof triggerClickClose === "function") {
      triggerClickClose(this.activeElement);
    } else if (this.activeElement) {
      this.activeElement.focus();
    }
  }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }
    cartDrawerNote.parentElement.addEventListener("keyup", escClick);
  }
  renderContents(parsedState) {
    const drawerInner = this.querySelector(".drawer-inner");
    if (drawerInner) drawerInner.classList.remove("is-empty");
    this.productId = parsedState.id;
    this.fetchSecToInclude().forEach((section) => {
      const sectionMarkup = parsedState.sections?.[section.id];
      if (!sectionMarkup) return;
      if (section.id === "ajax-cart-icon") {
        const sourceCount = this.getSectionDOM(sectionMarkup, ".bigcounter");
        if (!sourceCount) return;
        document.querySelectorAll(".bigcounter").forEach((count) => {
          count.innerHTML = sourceCount.innerHTML;
        });
        return;
      }
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      const source = this.getSectionDOM(sectionMarkup, section.selector);
      if (sectionElement && source) sectionElement.innerHTML = source.innerHTML;
    });
    setTimeout(() => {
      const overlay = this.querySelector("#ajaxcart-overlay");
      if (overlay) overlay.addEventListener("click", this.close.bind(this));
      this.open();
    });
  }
  callSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
  fetchSecToInclude() {
    return [
      {
        id: "ajax-cart",
        selector: "#ajaxcart",
      },
      {
        id: "ajax-cart-icon",
      },
    ];
  }
  getSectionDOM(html, selector = ".shopify-section") {
    if (!html) return null;
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
if (!customElements.get("ajax-cart")) customElements.define("ajax-cart", ajaxCart);
class ajaxCartPro extends CartProduct {
  fetchSecToInclude() {
    return [
      {
        id: "ajaxcart",
        section: "ajax-cart",
        selector: ".drawer-inner",
      },
      {
        id: "ajax-cart-icon",
        section: "ajax-cart-icon",
        selector: ".bigcounter",
      },
    ];
  }
}

if (!customElements.get("cart-pro")) customElements.define("cart-pro", ajaxCartPro);
